import { LoanStep } from 'even-ts-static'
import * as React from 'react'
import { connect } from 'react-redux'

import { configIncentivesEnabledSelector } from 'embed/selectors/config'
import { MultiProductState } from 'embed/reducers'
import {
  uiSelectedLoanStepIsResultsSelector,
  uiSelectedLoanStepIsResultsWithLoanOffersSelector,
  uiSelectedLoanStepSelector,
} from 'embed/selectors/ui'
import Loan from './index'

interface StoreProps {
  selectedStep: LoanStep
  incentivesEnabled: boolean
  isResultsStep: boolean
  isResultsStepWithLoanOffers: boolean
}

const LoanContainer: React.SFC<StoreProps> = (props) => <Loan {...props} />

const mapStateToProps = (state: MultiProductState): StoreProps => ({
  incentivesEnabled: configIncentivesEnabledSelector(state),
  isResultsStep: uiSelectedLoanStepIsResultsSelector(state),
  isResultsStepWithLoanOffers: uiSelectedLoanStepIsResultsWithLoanOffersSelector(state),
  selectedStep: uiSelectedLoanStepSelector(state),
})

export default connect<StoreProps>(mapStateToProps, {})(LoanContainer)
